<template>
  <img
    src="https://static.wangsu.com/lib/images/status/v1/403.min.svg"
    alt="403"
  />
</template>
<script setup lang="ts">
import { defineComponent } from 'vue'

defineComponent({
  name: 'ElResultIcon403',
})
</script>
